module.exports = __webpack_public_path__ + "static/media/travis-scott-astroworld-album-art-2018-billboard-embed@2x.9e5b284c.png";